import React from "react"
import { AppHeader } from "@citydna/common"
import { AuthButton } from "./AuthButton"
import { useSetHeight } from "./HeightProvider"

export const Header: React.FC = () => {
  const ref = useSetHeight("header")
  return <AppHeader title="Feature editor" right={<AuthButton />} ref={ref} />
}
